import { MouseEvent, ReactNode } from 'react';
import { Tooltip, Button, mergeClasses } from '@fluentui/react-components';
import { TIcon } from '@shared/types';
import { Editor } from '@tiptap/react';
import useEditorActive from '../../../hooks/useEditorActive.hook';
import useToolbarButtonStyles from '../../../hooks/useToolbarButtonStyles.hook';
import { isLockedOutsideFields } from '../../../tiptap/extensions/TemplateLocking';

type Props = {
  icon: TIcon;
  tooltip?: any;
  children?: ReactNode;
  disabled?: (editor: Editor) => boolean;
  /** Skip the locked-document gate: for actions that work without editing the doc (undo, view aids). */
  worksWhenLocked?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => unknown;
  className?: string;
  style?: any;
};

const ToolbarButton = ({
  icon,
  tooltip = null,
  children = null,
  disabled,
  worksWhenLocked = false,
  onClick = undefined,
  className = '',
  style = {},
}: Props) => {
  const classes = useToolbarButtonStyles();
  // Central gate: the locked body of a bound document silently filters every edit.
  const isDisabled = useEditorActive(
    (editor) => (disabled ? disabled(editor) : false) || (!worksWhenLocked && isLockedOutsideFields(editor.state))
  );

  let classNameButton = mergeClasses(classes.root, className);
  if (children) classNameButton = mergeClasses(classNameButton, classes.reducePadding);
  if (isDisabled) classNameButton = mergeClasses(classNameButton, classes.disabled);

  const content = (
    <Button className={classNameButton} icon={icon} disabled={isDisabled} onClick={onClick} style={style}>
      {children}
    </Button>
  );
  if (!tooltip) return content;

  return (
    <Tooltip content={tooltip} relationship="label" withArrow>
      {content}
    </Tooltip>
  );
};

export default ToolbarButton;
